import { render, staticRenderFns } from "./PrintingA4.vue?vue&type=template&id=769765c2&scoped=true"
import script from "./PrintingA4.vue?vue&type=script&lang=js"
export * from "./PrintingA4.vue?vue&type=script&lang=js"
import style0 from "./PrintingA4.vue?vue&type=style&index=0&id=769765c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769765c2",
  null
  
)

export default component.exports